import { render } from "./WizardConvoy.vue?vue&type=template&id=66b5b906"
import script from "./WizardConvoy.vue?vue&type=script&lang=js"
export * from "./WizardConvoy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__